// Custom function to format numbers for example 99999999.99 to 99,999,999.99
export function formatNumber(value?: number): string {
  if (!value) return '';
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
